import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for deleteProfile mutation
 */
export interface DeleteProfileVariables {
  profileId: string;
}

/**
 * Deleted profile structure
 */
export interface DeletedProfile {
  id: string;
}

/**
 * Delete profile payload structure
 */
export interface DeleteProfilePayload {
  profile: DeletedProfile;
}

/**
 * Response structure for deleteProfile mutation
 */
export interface DeleteProfileResponse {
  deleteProfile: DeleteProfilePayload;
}

const deleteProfile: DocumentNode = gql`
  mutation delete_user($profileId: ID!) {
    deleteProfile(profileId: $profileId) {
      profile {
        id
      }
    }
  }
`;

export default deleteProfile;
